import _sortBy from 'lodash/sortBy';
import _extend from 'lodash/extend';
import _reject from 'lodash/reject';
import MEMBERSHIP_STATUSES from 'constants/membershipStatuses';

function Ctrl($rootScope, $scope, $uibModalInstance, utilsService, jsSdkUser, jsSdkMembership, membershipService) {
  const actions = {
    UPDATE_PAYMENT_METHOD: 'UPDATE_PAYMENT_METHOD'
  };

  $scope.error = null;
  $scope.success = null;

  $scope.loading = true;

  getUserMembership();

  $scope.membershipStates = membershipService.getStates();

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.save = function(membership, paymentProfile) {
    $scope.error = null;
    $scope.success = null;

    if (!membership || !membership.id) {
      $scope.error = 'Missing membership id.';
      return;
    }

    if (!paymentProfile || !paymentProfile.id) {
      $scope.error = 'Unable to update payment';
      return;
    }

    updatePayment(membership.id, paymentProfile.id);
  };

  function getUserMembership() {
    const user = jsSdkUser.getCurrentUser();

    if (!user || !user.id) {
      return;
    }

    $scope.loading = true;

    jsSdkMembership.listByUserId(user.id, {})
      .then(resp => {
        $scope.loading = false;

        const memberships = _sortBy(_reject(resp, {
          status: MEMBERSHIP_STATUSES.CANCELLED
        }), 'created');

        if (memberships && memberships[0]) {
          $scope.membership = memberships[0];
        }
      })
      .catch(resp => {
        $scope.error = utilsService.errorMessage(resp);
        $scope.loading = false;
      });
  }

  function updatePayment(membershipId, paymentProfileId) {

    $scope.error = null;
    $scope.loading = true;

    const options = {
      paymentProfileId: paymentProfileId
    };

    return jsSdkMembership.performAction(membershipId, actions.UPDATE_PAYMENT_METHOD, options)
      .then(() => {
        $scope.loading = false;
        $scope.success = 'Payment method updated.';

        membershipUpdated();
      })
      .catch(resp => {
        $scope.error = utilsService.errorMessage(resp);
        $scope.loading = false;
      });
  }

  function membershipUpdated() {
    getUserMembership();

    jsSdkUser.me()
      .then(currentUser => {
        _extend($rootScope.currentUser, currentUser);
      });
  }
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$uibModalInstance',
  'utilsService',
  'jsSdk.user',
  'jsSdk.membership',
  'membershipService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/services/modal/editMembership/editMembershipModalCtrl.js